import React from 'react';

export const ImageInfoDiv = () => {
    return(
        <div className='userPhotosInfo'>
            <p>Image formats: .jpeg | .jpg</p><br/>
            <p>Photos should be close to 2000 pixels wide</p><br/>
            <p>Upload all your images here and select images for each level in Image library. 
            Or, you can upload images one level at a time.</p><br/>
            <p>You can create iFloorPlans with static images or 360 panoramas, or both.</p>
        </div>
    )
}

export const MultipleFloorplansInfoDiv = () => {
    return(
        <div className='userPhotosInfo'>
            Image formats:<br/>
            .jpeg | .jpg | .png | .gif<br/>
            <br/>
            Floor plans should be at least 1000px high but a higher pixel size is recommended.<br/>
            <br/>
            Multiple levels:<br/>
            Within the editor you can use the Crop tool to create a multi-level iFloorPlan
            from one floor plan image that shows different levels of a property.<br/>
            Or you can upload separate batches of images of each level.<br/>
        </div>
    )
}

export const SingleFloorplanInfoDiv = () => {
    return(
        <div className='userPanoramasInfo'>
            Image formats:<br/>
            .jpeg | .jpg | .png | .gif<br/>
            <br/>
            Floor plans should be at least 1000px high but a higher pixel size is recommended.<br/>
            <br/>
            Multiple levels:<br/>
            Within the editor you can use the Crop tool to create a multi-level iFloorPlan
            from one image that shows different levels of a property.<br/>
            Or you can upload separate batches of images of each level.<br/>
        </div>
    )
}

export const Pano360ImageInfoDiv = () => {
    return(
        <div className='userPanoramasInfo'>
            Image formats:<br/>
            .jpeg | .jpg<br/>
            <br/>
            360 panorama images should be about 4000px wide.<br/>
            <br/>
            Multiple levels:<br/>
            Upload all your images here. You can select images for each level in the Image library.
            Or you can upload images each time you create a level.<br/>
        </div>
    )
}
